// src/hooks/usePayments/usePayments.js
import {
  fetchClient,
  rqClient,
  publicRqClient,
} from "../../shared/api/instance";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export function useInvalidatePayments() {
  const queryClient = useQueryClient();

  return (customerId, type = null) => {
    if (customerId) {
      const specificQueryKey = rqClient.queryOptions(
        "get",
        "/payments/v1/payments",
        {
          params: {
            query: {
              customerId,
              ...(type ? { type } : {}),
              page: 0,
              size: 1,
              sort: ["id,asc"],
            },
          },
        }
      ).queryKey;

      queryClient.invalidateQueries({ queryKey: specificQueryKey });
    }

    // queryClient.invalidateQueries({
    //   queryKey: ["payments", customerId],
    // });

    // // И все payments запросы вообще (на всякий случай)
    // queryClient.invalidateQueries({
    //   queryKey: ["payments"],
    // });
  };
}

export function useGetPayments(
  { customerId, type, page = 0, size = 1, sort = "id,desc" },
  { enabled = true } = {}
) {
  return rqClient.useQuery(
    "get",
    "/payments/v1/payments",
    {
      params: {
        query: {
          customerId,
          type,
          page,
          size,
          sort: Array.isArray(sort) ? sort : [sort],
        },
      },
    },
    {
      enabled: enabled && !!customerId,
      // staleTime: 1000 * 60 * 5, // 5 minutes cache
    }
  );
}

export function useGetPaymentItems(
  { type, partnerId, region, city },
  { enabled }
) {
  const { data, isLoading } = useQuery({
    queryKey: ["payment-items", region, city, partnerId, type],
    queryFn: async ({ pageParam = 0 }) => {
      const res = await fetchClient.GET("/payments/v1/items", {
        params: {
          query: {
            type,
            partnerId,
            region,
            city,
          },
        },
      });
      return res.data?.data || [];
    },
    enabled, //: true, //false
  });

  return {
    items: data,
    isLoading,
  };
}

export function useGetPaymentItemsPublic(
  { type, partnerId, eventId, region, city },
  { enabled }
) {
  return publicRqClient.useQuery(
    "get",
    "/payments/v1/items",
    {
      params: {
        query: {
          type,
          partnerId,
          region,
          city,
          eventId,
        },
      },
    },
    {
      enabled,
    }
  );
}
